class CartoCiudadSearchConfig {
    #q;
    #cod_postal_filter;
    #municipio_filter;
    #provincia_filter;
    #comunidad_autonoma;
    #poblacion_filter;
    #countrycodes;
    #limit;

    get q() {
        return this.#q;
    }

    get cod_postal_filter() {
        return this.#cod_postal_filter;
    }

    get municipio_filter() {
        return this.#municipio_filter;
    }

    get provincia_filter() {
        return this.#provincia_filter;
    }

    get comunidad_autonoma() {
        return this.#comunidad_autonoma;
    }

    get poblacion_filter() {
        return this.#poblacion_filter;
    }

    get countrycodes() {
        return this.#countrycodes;
    }

    get limit() {
        return this.#limit;
    }

    constructor(
        q,
        cod_postal_filter,
        municipio_filter,
        provincia_filter,
        comunidad_autonoma,
        poblacion_filter,
        countrycodes,
        limit
    ) {
        this.#q = q;
        this.#cod_postal_filter = cod_postal_filter;
        this.#municipio_filter = municipio_filter;
        this.#provincia_filter = provincia_filter;
        this.#comunidad_autonoma = comunidad_autonoma;
        this.#poblacion_filter = poblacion_filter;
        this.#countrycodes = countrycodes;
        this.#limit = limit;
    }

    getKey() {
        return `${this.q}`;
    }

    getURL() {
        const params = {
            q: this.q,
            cod_postal_filter: this.cod_postal_filter,
            municipio_filter: this.municipio_filter,
            provincia_filter: this.provincia_filter,
            comunidad_autonoma: this.comunidad_autonoma,
            poblacion_filter: this.poblacion_filter,
            countrycodes: this.countrycodes,
            limit: this.limit,
        };

        return Object.entries(params)
            .filter(([key, value]) => value != null && value !== "")
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join("&");
    }
}

const createCartoCiudadSearchConfig = ({
    q = null,
    cod_postal_filter = null,
    municipio_filter = null,
    provincia_filter = null,
    comunidad_autonoma = null,
    poblacion_filter = null,
    countrycodes = "es",
    limit = 20,
}) => {
    return new CartoCiudadSearchConfig(
        q,
        cod_postal_filter,
        municipio_filter,
        provincia_filter,
        comunidad_autonoma,
        poblacion_filter,
        countrycodes,
        limit
    );
};

export default createCartoCiudadSearchConfig;

class CartoCiudadFindConfig {
    #id;
    #type;

    get id() {
        return this.#id;
    }

    get type() {
        return this.#type;
    }

    constructor(id, type) {
        this.#id = id;
        this.#type = type;
    }

    getKey() {
        return `${this.id}`;
    }

    getURL() {
        return `id=${this.id}&type=${this.type}`;
    }
}

export const createCartoCiudadFindConfig = ({id = null, type = null}) => {
    return new CartoCiudadFindConfig(id, type);
};
